import React from 'react';
import PropTypes from 'prop-types';

import { CenteredContainer, Title, Button, Text } from '@nerdwallet/currency';

import styles from './footer.module.less';

const CompanyFooter = ({
  backgroundColor,
  contrastColor,
  ctaText,
  ctaUrl,
  isSmall,
  title,
  subtitle,
  imageUrlDesktop,
  imageUrlMobile,
}) => {
  const footerBackgroundColorDesktop = {
    backgroundImage: !isSmall
      ? `linear-gradient(${backgroundColor} 235px, ${contrastColor} 0px)`
      : null,
    backgroundColor: !isSmall ? null : `${backgroundColor}`,
  };

  const footerBackgroundColorMobile = {
    backgroundImage: !isSmall
      ? `linear-gradient(${backgroundColor} 176px, ${contrastColor} 0px)`
      : null,
    backgroundColor: !isSmall ? null : `${backgroundColor}`,
  };

  const footerBackgroundImageMobile = {
    backgroundImage: `url(${imageUrlMobile})`,
  };

  const footerBackgroundImageDesktop = {
    backgroundImage: `url(${imageUrlDesktop})`,
  };

  const footerContent = (
    <CenteredContainer className={styles.companyFooterCentered}>
      <Title size="small" className={styles.companyFooterTitle} component="h2">
        {title}
      </Title>
      <div>
        <Text>{subtitle}</Text>
      </div>
      {ctaUrl ? (
        <Button className={styles.companyFooterButton} href={ctaUrl} primary>
          {ctaText}
        </Button>
      ) : null}
    </CenteredContainer>
  );

  return (
    <React.Fragment>
      <div
        className={
          !isSmall
            ? styles.companyFooterContainerMobile
            : styles.companyFooterContainerMobileSmall
        }
        style={footerBackgroundColorMobile}
      >
        <div
          className={
            !isSmall
              ? styles.companyFooterOuter
              : styles.companyFooterOuterSmall
          }
          style={footerBackgroundImageMobile}
        >
          {footerContent}
        </div>
      </div>
      <div
        className={
          !isSmall
            ? styles.companyFooterContainerDesktop
            : styles.companyFooterContainerDesktopSmall
        }
        style={footerBackgroundColorDesktop}
      >
        <div
          className={
            !isSmall
              ? styles.companyFooterOuter
              : styles.companyFooterOuterSmall
          }
          style={footerBackgroundImageDesktop}
        >
          {footerContent}
        </div>
      </div>
    </React.Fragment>
  );
};

CompanyFooter.propTypes = {
  backgroundColor: PropTypes.string,
  contrastColor: PropTypes.string,
  ctaText: PropTypes.string,
  ctaUrl: PropTypes.string,
  imageUrlDesktop: PropTypes.string,
  imageUrlMobile: PropTypes.string,
  isSmall: PropTypes.bool,
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

CompanyFooter.defaultProps = {
  backgroundColor: '#EEF7FF',
  contrastColor: '#9DCDFA',
  isSmall: false,
};

CompanyFooter.displayName = 'Company Footer';

export default CompanyFooter;
